'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Search3 = function Search3(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 13 13' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'title',
        null,
        'Fill 1 Copy'
      ),
      _react2.default.createElement('path', { d: 'M2.969 8.295a3.772 3.772 0 0 1 0-5.316 3.714 3.714 0 0 1 2.647-1.1c1.001 0 1.941.391 2.649 1.1a3.773 3.773 0 0 1 0 5.316 3.717 3.717 0 0 1-2.649 1.1c-1 0-1.94-.391-2.647-1.1zM13 11.26l-2.675-2.555a5.65 5.65 0 0 0-.736-7.055A5.586 5.586 0 0 0 5.616 0C4.18 0 2.741.55 1.646 1.65a5.652 5.652 0 0 0 0 7.973 5.587 5.587 0 0 0 3.97 1.652c1.215 0 2.416-.417 3.425-1.203l2.668 2.55L13 11.26z',
        fill: 'currentColor', fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

exports.default = Search3;
//# sourceMappingURL=Search3.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/Search3.js